<template>
  <div class="card-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>{{ $t("sale.card.title") }}</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'createCard' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          :currentPage="params.page"
          :pageSize="params.limit"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination :pageSize="params.limit" :total="total" @pageNum="pageNum" />
    </el-card>
  </div>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import ListSearch from "@/components/listSearch";
import listMixin from "@/mixins/list";
export default {
  mixins: [listMixin],
  components: {
    AppTable,
    Pagination,
    ListSearch
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "title",
          label: this.$t("sale.card.name")
        },
        {
          prop: "CardCount",
          label: this.$t("sale.card.cardCount")
        },
        {
          prop: "cardOutCount",
          label: this.$t("sale.card.cardOutCount")
        },
        {
          prop: "cardResCount",
          label: this.$t("sale.card.cardResCount")
        },
        {
          prop: "liveAt",
          label: "有效期"
        },
        {
          width: 200,
          prop: "cardHandle",
          label: this.$t("org.manage")
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: { limit: 20, page: 1, sortBy: "createdAt" },
      cardItem: {}
    };
  },
  methods: {
    getList() {
      this.$http.getCards(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    delete(id) {
      this.$http.delCard({id: id}).then(res => {
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getList();
        }).catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },
    edit(data) {
      this.$router.push({ name: "createCard", query: { id: data.row._id } });
    },
    del(data) {
      this.delete(data.row._id);
    },
    toDetails(data) {
      this.cardItem = data.row;
      this.$router.push({ name: "detailsCard", query: { id: data.row._id } });
    },
    pageNum(page) {
      this.params.page = page;
      this.getList();
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.card-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}
</style>
